import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FormList } from "../Formular/FormList";
import { InputErrorMessage } from "./InputErrorMessage";

const FormListInput = ({ name, label, rules = {}, setValueAs = (v) => v, ...props }) => {
    const { control, errors } = useFormContext();

    return (
        <div className="form-group">
            {label && <label>{label + (rules.required ? " *" : "")}</label>}
            <Controller
                control={control}
                rules={rules}
                name={name}
                render={({ field: { value, onChange } }) => (
                    <FormList selected={value} cb={(v) => onChange(setValueAs(v))} {...props} />
                )}
            />
            <InputErrorMessage errors={errors} name={name} />
        </div>
    );
};

export default FormListInput;
